import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <Hero data-id="element-1" data-mp="28tmex2vosax8" />
      <main data-id="element-2" data-mp="28te2fc3h77mk">
        <TestimonialsSection data-id="element-3" data-mp="28suumo7jhzm9" />
        <ProblemSection data-id="element-4" data-mp="28s2x37udtrtc" />
        <VolumesSection data-id="element-5" data-mp="23vkzcrxgytqi" />
        <BonusesSection data-id="element-6" data-mp="23u9vks40xlze" />
        <OfferSection data-id="element-7" data-mp="23v2rsz5cwt3a" />
        <GuaranteeSection data-id="element-8" data-mp="23ti5txx3yih1" />
        <FaqSection data-id="element-9" data-mp="3ikh9me1wn113" />
        <FinalCtaSection data-id="element-10" data-mp="3ij652c0mxp8x" />
      </main>
      <Footer data-id="element-11" data-mp="3ii4t85bsoyq5" />
      <StickyCta data-id="element-12" data-mp="3mlj8uuvtnd32" />
    </div>;
}